import { render, staticRenderFns } from "./ContentCover.vue?vue&type=template&id=75d66e1e&"
import script from "./ContentCover.vue?vue&type=script&lang=ts&"
export * from "./ContentCover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports